import React from 'react';
const Footer = () => {
  return (
    <footer className="flex-none border-t border-gray-100 bg-white px-6 py-3">
      <div className="text-center text-xs text-gray-400">
        Copyright &copy; ATOS 안전 센터 1566-3886
      </div>
    </footer>
  );
};

export default Footer;
